import i18next from 'i18next';

import { FilterDefinitionType } from 'enums';
import { FilterDefinition, TransactionsFilters, User } from 'types';

const getCommonFilters = (
  users?: User[],
): FilterDefinition<Partial<TransactionsFilters>>[] => {
  const { t } = i18next;
  const filters: FilterDefinition<Partial<TransactionsFilters>>[] = [
    {
      label: t('filters.user_wallet'),
      name: 'address',
      type: FilterDefinitionType.Text,
    },
    {
      label: t('filters.amount'),
      type: FilterDefinitionType.Range,
      minName: 'minAmount',
      maxName: 'maxAmount',
    },
  ];
  if (users) {
    filters.push({
      label: t('filters.user'),
      name: 'userId',
      type: FilterDefinitionType.User,
      users,
    });
  }
  return filters;
};

export const transactionsUtils = {
  getCommonFilters,
};
